import {
	DOC_SIGNED,
	DOC_SIGNING,
	DOC_SIGNING_FAILED,
	DOC_SIGNING_INITIALIZE,
} from "../actions/types";
const initialState = {
	isSigning: false,
	isSigned: false,
	isFailed: false,
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DOC_SIGNING:
			return {
				...state,
				isSigning: true,
				isSigned: false,
				isFailed: false,
			};
		case DOC_SIGNED:
			return {
				...state,
				isSigning: false,
				isSigned: true,
				isFailed: false,
			};
		case DOC_SIGNING_INITIALIZE:
			return {
				...state,
				isSigning: false,
				isSigned: false,
				isFailed: false,
			};

		case DOC_SIGNING_FAILED:
			return {
				...state,
				isSigning: false,
				isSigned: false,
				isFailed: false,
			};

		default:
			return state;
	}
}
